import {
  SEARCH_GUESTS_URL,
  VISIT_URL
} from 'app/utils/Constants';

import {
  post,
  get
} from 'app/services/ApiService';

import {
  OPERATOR_KEY,
  OR_OPERATOR,
  AND_OPERATOR
} from 'app/utils/Constants';

import {
  TEXT,
  EQUALS
} from 'app/hooks/useFilter';

export const searchGuests = async (page, perPage, filterValue, jobId) => {
  let filterModel = {
    [OPERATOR_KEY]: [{ value: OR_OPERATOR }]
  }

  if (filterValue) {
    let filter = {
      filterClass: 'text',
      filterType: 'contains',
      value: filterValue,
      operator: OR_OPERATOR
    }

    filterModel = {
      ...filterModel,
      name: [filter],
      email: [filter],
      phone: [filter],
      access_code: [filter]
    }
  }

  if (jobId) {
    filterModel.job_id = [{
      filterClass: 'text',
      filterType: 'equals',
      value: jobId.toString(),
      operator: AND_OPERATOR
    }];
  }

  let params = {
    page,
    per_page: perPage,
    filter_model: filterModel,
    sort_model: []
  }

  let resp = await getGuests(params);

  return resp.records;
}

export const getGuest = async id => {
  let params = {
    page: 1,
    per_page: 1,
    filter_model: {
      id: [{
        filterClass: TEXT,
        filterType: EQUALS,
        value: id.toString()
      }]
    },
    sort_model: []
  }

  let resp = await getGuests(params);
  return resp.records[0];
}

export const getGuests = async params => {
  return await post(SEARCH_GUESTS_URL(), params);
}

export const getVisit = async id => {
  return await get(VISIT_URL(id));
}
